import {
  WEB_STORAGE,
  WEB_STORAGE_LOCAL,
  WEB_STORAGE_UPDATE_DEPRECATED_KEYS,
} from "../settings";

export type WebStorage = typeof WEB_STORAGE;

export type WebStorageKey = keyof WebStorage;

export function webStorage<Key extends WebStorageKey>(key: Key) {
  const storageType = WEB_STORAGE_LOCAL.includes(key)
    ? "localStorage"
    : "sessionStorage";

  const storage = window[storageType];
  const storageKey = `faye:webStorage:${key}`;
  const deprecatedKeys = WEB_STORAGE_UPDATE_DEPRECATED_KEYS[key];

  if (deprecatedKeys?.length) {
    for (const deprecatedKey of deprecatedKeys) {
      const value = storage.getItem(deprecatedKey);

      if (value) {
        storage.removeItem(deprecatedKey);
        storage.setItem(storageKey, value);
      }
    }
  }

  return {
    get() {
      const value = storage.getItem(storageKey);
      return value !== null
        ? (JSON.parse(value) as WebStorage[Key])
        : WEB_STORAGE[key];
    },

    remove() {
      storage.removeItem(storageKey);
    },

    set(value: WebStorage[Key]) {
      storage.setItem(storageKey, JSON.stringify(value));
    },
  };
}
